import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 40,
    height: 36,
    fill: "transparent"
  }
});

class IcWhiteArrowLeft extends React.Component {

  render() {
    const { classes, className, onClick } = this.props;
    
    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 40 36" } 
                    onClick = { onClick } >
      <rect x="1" y="1" width="38" height="34" rx="3" fill="#201600" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
      <path d="M22.5 24.75L15 18L22.5 11.25" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcWhiteArrowLeft);